import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line no-restricted-imports
import { Form as FForm } from 'react-final-form';
import { getComponentDebugName } from '@/js/libs/reatom-devtools';
import { subscribedForms } from './utils';
export const Form = ({ children, ...props }) => {
    const name = getComponentDebugName('FinalForm');
    return (_jsx(FForm, { ...props, children: typeof children === 'function'
            ? (renderProps) => {
                const { values } = renderProps;
                const form = renderProps.form;
                if (DEVTOOLS) {
                    const state = DEVTOOLS.state(name, values);
                    if (!subscribedForms.has(form)) {
                        state.subscribe((newState) => {
                            // @ts-expect-error no need validation for devtools
                            form.initialize(newState);
                        });
                        subscribedForms.add(form);
                    }
                }
                return children(renderProps);
            }
            : children }));
};
